const scrollLockClass = 'bc-document-scroll-locked';
let lockCount = 0;
let addedScrollLockClass = false;

export const lockDocumentScroll = () => {
  if (typeof document === 'undefined') return;

  if (lockCount === 0) {
    addedScrollLockClass = !document.documentElement.classList.contains(scrollLockClass);
    document.documentElement.classList.add(scrollLockClass);
  }

  lockCount += 1;
};

export const unlockDocumentScroll = () => {
  if (typeof document === 'undefined' || lockCount === 0) return;

  lockCount -= 1;
  if (lockCount > 0) return;

  if (addedScrollLockClass) document.documentElement.classList.remove(scrollLockClass);
  addedScrollLockClass = false;
};
